__turbopack_context__.v({
  "block": "Ho6STW_block",
  "blockLifted": "Ho6STW_blockLifted",
  "count": "Ho6STW_count",
  "crCount": "Ho6STW_crCount",
  "fieldLabel": "Ho6STW_fieldLabel",
  "fieldList": "Ho6STW_fieldList",
  "fieldValue": "Ho6STW_fieldValue",
  "leftCol": "Ho6STW_leftCol",
  "reveal": "Ho6STW_reveal",
  "revealVisible": "Ho6STW_revealVisible",
  "rightCol": "Ho6STW_rightCol",
  "root": "Ho6STW_root",
  "sideBlock": "Ho6STW_sideBlock",
  "source": "Ho6STW_source",
  "sourceVisible": "Ho6STW_sourceVisible",
});
